import { render, staticRenderFns } from "./CheckOrRule.vue?vue&type=template&id=a63553fe&scoped=true"
import script from "./CheckOrRule.vue?vue&type=script&lang=js"
export * from "./CheckOrRule.vue?vue&type=script&lang=js"
import style0 from "./CheckOrRule.vue?vue&type=style&index=0&id=a63553fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63553fe",
  null
  
)

export default component.exports